export default "__VITE_ASSET__26c2e848__"